export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Google Business-oplysninger',
    google_reviews: 'Google-anmeldelser',
    settings: 'Indstillinger',
    danger_zone: 'Farezone',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'AI-autosvar',
    },
    reviews_autopilot_daily_limit: {
      label: 'Daglig grænse for AI-autosvar (min. 1, maks. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Antal timer, der skal gå efter en anmeldelse er skrevet',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Vis alle anmeldelser',
      show_only_unanswered: 'Vis kun ubesvarede',
    },
    rating_filter: {
      label: 'Vurderingsfilter',
      stars_one: '{{count}} stjerne',
      stars_other: '{{count}} stjerner',
    },
    sorting: {
      newest_to_oldest: 'Sortér efter nyeste til ældste',
      oldest_to_newest: 'Sortér efter ældste til nyeste',
      rating_highest_to_lowest: 'Sortér efter højeste til laveste vurdering',
      rating_lowest_to_highest: 'Sortér efter laveste til højeste vurdering',
    },
  },
  table: {
    pagination: {
      total_one: 'I alt {{count}} anmeldelse',
      total_other: 'I alt {{count}} anmeldelser',
    },
  },
  modal_publish: {
    title: 'Er du sikker på, at du vil publicere til Google?',
    buttons: {
      yes: 'Ja',
      cancel: 'Annullér',
    },
  },
  popconfirm: {
    title: 'Er du sikker?',
    description: 'Alle lokale ændringer bliver overskrevet',
  },
  disconnect_profile: {
    title: 'Afbryd profil',
    button: 'Fortsæt',
    popconfirm: {
      title: 'Er du sikker?',
      description:
        'Dette afbryder helt forbindelsen mellem denne Google-profil og FoodAmigos-systemet, inklusive automatisk udskiftning af links og autopilot til anmeldelsessvar!',
    },
  },
  buttons: {
    login_with_google: 'Log ind med Google',
    sync_from_google: 'Hent nyeste version',
    publish_to_google: 'Publicér til Google',
    previous: 'Forrige',
    next: 'Næste',
    save_settings: 'Gem indstillinger',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    failed_to_fetch_reviews: 'Anmeldelserne kunne ikke hentes',
    failed_to_fetch_settings: 'Indstillingerne kunne ikke hentes',
    failed_to_load_google_business: 'Google Business kunne ikke indlæses',
    failed_to_publish_to_google_business: 'Publicering til Google Business mislykkedes',
    publish_access_denied:
      'Google har afvist opdateringen: den tilsluttede Google-konto kan ikke længere redigere denne virksomhedsprofil. Tjek kontoens adgang i Google Business Profile, eller tilslut igen med den konto, der administrerer restauranten.',
    failed_to_fetch_info: 'Den nyeste version af Google Business kunne ikke hentes',
    success_publish_to_google_business: 'Publiceret til Google Business',
    success_sync_from_google: 'Synkroniseret fra Google Business',
    success_save_settings: 'Indstillingerne er gemt',
    failed_to_disconnect_profile: 'Google Business kunne ikke afbrydes. Kontakt det tekniske team!',
    popup_blocked: 'Tillad pop op-vinduer for dette websted for at forbinde Google Business.',
    failed_to_connect: 'Google Business kunne ikke forbindes. Prøv igen.',
    no_business_profile:
      'Denne Google-konto administrerer ikke en virksomhedsprofil. Log ind med den Google-konto, der administrerer restauranten.',
  },
  callback: {
    connecting: 'Forbinder Google Business…',
    connected: 'Google Business er forbundet. Du kan lukke dette vindue.',
    cancelled: 'Login blev annulleret. Du kan lukke dette vindue.',
    failed: 'Google Business kunne ikke forbindes. Luk dette vindue, og prøv igen.',
  },
  alerts: {
    no_profile: {
      title: 'Intet Google-sted forbundet',
      description: 'Forbind restauranten til et Google-sted.',
      button: {
        connect: 'Forbind',
      },
    },
    unverified_location: {
      title: 'Google Business er ikke bekræftet',
      description: 'Bekræft din Google Business for at fortsætte',
    },
  },
};
